
export default function SiniestradosInfo() {
  return (
    <section className="py-12 sm:py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Content */}
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-8 sm:mb-12">
            <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-teal-100 text-teal-700 rounded-full mb-3 sm:mb-4">
              <i className="ri-information-line text-base sm:text-lg"></i>
              <span className="text-xs sm:text-sm font-semibold whitespace-nowrap">INFORMACIÓN COMPLETA</span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
              Vender Coche Siniestrado en <strong>Castelldefels</strong>
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600 px-2">
              Todo lo que necesitas saber sobre la venta de coches siniestrados, accidentados o averiados en Castelldefels
            </p>
          </div>

          {/* Content Sections */}
          <article className="prose prose-sm sm:prose-lg max-w-none">
            {/* Section 1 */}
            <div className="bg-gray-50 rounded-xl sm:rounded-2xl p-5 sm:p-8 mb-6 sm:mb-8">
              <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                ¿Qué es un Coche Siniestrado?
              </h3>
              <p className="text-gray-600 leading-relaxed mb-3 sm:mb-4 text-sm sm:text-base">
                Un <strong>coche siniestrado</strong> es un vehículo que ha sufrido un accidente de tráfico y presenta daños significativos. En Castelldefels, compramos todo tipo de coches siniestrados: desde vehículos con daños leves hasta coches totalmente siniestrados con pérdida total declarada por la aseguradora.
              </p>
              <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
                Los coches siniestrados pueden tener daños en la carrocería, motor, chasis, sistema eléctrico o cualquier otro componente. No importa la gravedad del siniestro, en nuestro desguace de Castelldefels compramos tu coche siniestrado y te pagamos al instante.
              </p>
            </div>

            {/* Section 2 */}
            <div className="bg-gray-50 rounded-xl sm:rounded-2xl p-5 sm:p-8 mb-6 sm:mb-8">
              <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                Tipos de Coches Siniestrados que Compramos
              </h3>
              <div className="grid sm:grid-cols-2 gap-4 sm:gap-6">
                <div>
                  <h4 className="font-bold text-gray-900 mb-2 sm:mb-3 flex items-center gap-2 text-sm sm:text-base">
                    <i className="ri-checkbox-circle-fill text-teal-600"></i>
                    Coches Accidentados
                  </h4>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                    Vehículos que han sufrido colisiones frontales, laterales o traseras. Compramos coches accidentados en Castelldefels con cualquier tipo de daño estructural o mecánico.
                  </p>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2 sm:mb-3 flex items-center gap-2 text-sm sm:text-base">
                    <i className="ri-checkbox-circle-fill text-teal-600"></i>
                    Coches Chocados
                  </h4>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                    Vehículos con daños por impacto. Desde pequeños golpes hasta choques graves. Te damos el mejor precio por tu coche chocado en Castelldefels.
                  </p>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2 sm:mb-3 flex items-center gap-2 text-sm sm:text-base">
                    <i className="ri-checkbox-circle-fill text-teal-600"></i>
                    Coches Volcados
                  </h4>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                    Vehículos que han sufrido vuelcos o volcamientos. Compramos coches volcados con daños en techo, laterales y estructura general.
                  </p>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2 sm:mb-3 flex items-center gap-2 text-sm sm:text-base">
                    <i className="ri-checkbox-circle-fill text-teal-600"></i>
                    Pérdida Total
                  </h4>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                    Coches declarados siniestro total por la aseguradora. Compramos vehículos con pérdida total en Castelldefels y gestionamos toda la documentación.
                  </p>
                </div>
              </div>
            </div>

            {/* Section 3 */}
            <div className="bg-gray-50 rounded-xl sm:rounded-2xl p-5 sm:p-8 mb-6 sm:mb-8">
              <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                Ventajas de Vender tu Coche Siniestrado en Castelldefels
              </h3>
              <ul className="space-y-3 sm:space-y-4">
                <li className="flex items-start gap-2 sm:gap-3">
                  <i className="ri-check-double-line text-xl sm:text-2xl text-teal-600 flex-shrink-0 mt-0.5"></i>
                  <div>
                    <strong className="text-gray-900 text-sm sm:text-base">Valoración Inmediata:</strong>
                    <span className="text-gray-600 text-sm sm:text-base"> Te damos un precio justo por tu coche siniestrado en menos de 1 hora. Sin esperas ni complicaciones.</span>
                  </div>
                </li>
                <li className="flex items-start gap-2 sm:gap-3">
                  <i className="ri-check-double-line text-xl sm:text-2xl text-teal-600 flex-shrink-0 mt-0.5"></i>
                  <div>
                    <strong className="text-gray-900 text-sm sm:text-base">Recogida Gratuita:</strong>
                    <span className="text-gray-600 text-sm sm:text-base"> Servicio de grúa incluido sin coste adicional en Castelldefels. Recogemos tu coche siniestrado donde esté.</span>
                  </div>
                </li>
                <li className="flex items-start gap-2 sm:gap-3">
                  <i className="ri-check-double-line text-xl sm:text-2xl text-teal-600 flex-shrink-0 mt-0.5"></i>
                  <div>
                    <strong className="text-gray-900 text-sm sm:text-base">Pago al Instante:</strong>
                    <span className="text-gray-600 text-sm sm:text-base"> Te pagamos en efectivo o transferencia inmediata. Dinero rápido y seguro por tu coche siniestrado.</span>
                  </div>
                </li>
                <li className="flex items-start gap-2 sm:gap-3">
                  <i className="ri-check-double-line text-xl sm:text-2xl text-teal-600 flex-shrink-0 mt-0.5"></i>
                  <div>
                    <strong className="text-gray-900 text-sm sm:text-base">Gestión de Baja:</strong>
                    <span className="text-gray-600 text-sm sm:text-base"> Tramitamos la baja definitiva en DGT. Te entregamos el certificado de destrucción. Sin gestiones para ti.</span>
                  </div>
                </li>
                <li className="flex items-start gap-2 sm:gap-3">
                  <i className="ri-check-double-line text-xl sm:text-2xl text-teal-600 flex-shrink-0 mt-0.5"></i>
                  <div>
                    <strong className="text-gray-900 text-sm sm:text-base">Sin Reparaciones:</strong>
                    <span className="text-gray-600 text-sm sm:text-base"> No necesitas reparar nada. Compramos tu coche siniestrado tal como está, con todos sus daños.</span>
                  </div>
                </li>
              </ul>
            </div>

            {/* Section 4 */}
            <div className="bg-gradient-to-r from-teal-50 to-cyan-50 rounded-xl sm:rounded-2xl p-5 sm:p-8 mb-6 sm:mb-8">
              <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                ¿Cuánto Vale un Coche Siniestrado en Castelldefels?
              </h3>
              <p className="text-gray-600 leading-relaxed mb-3 sm:mb-4 text-sm sm:text-base">
                El valor de un <strong>coche siniestrado</strong> depende de varios factores: marca, modelo, año, tipo de daños, estado general y valor de las piezas recuperables. En nuestro desguace de Castelldefels, hacemos una valoración justa considerando todos estos aspectos.
              </p>
              <p className="text-gray-600 leading-relaxed mb-3 sm:mb-4 text-sm sm:text-base">
                Aunque tu coche esté muy dañado, siempre tiene valor. Las piezas en buen estado, los metales y componentes recuperables tienen un precio en el mercado. Te garantizamos el mejor precio por tu coche siniestrado en Castelldefels.
              </p>
              <div className="bg-white rounded-lg sm:rounded-xl p-4 sm:p-6 mt-4 sm:mt-6">
                <h4 className="font-bold text-gray-900 mb-2 sm:mb-3 text-sm sm:text-base">Factores que Determinan el Precio:</h4>
                <div className="grid grid-cols-2 gap-2 sm:gap-4">
                  <div className="flex items-center gap-1 sm:gap-2">
                    <i className="ri-arrow-right-s-line text-teal-600"></i>
                    <span className="text-gray-600 text-xs sm:text-sm">Marca y modelo</span>
                  </div>
                  <div className="flex items-center gap-1 sm:gap-2">
                    <i className="ri-arrow-right-s-line text-teal-600"></i>
                    <span className="text-gray-600 text-xs sm:text-sm">Año de fabricación</span>
                  </div>
                  <div className="flex items-center gap-1 sm:gap-2">
                    <i className="ri-arrow-right-s-line text-teal-600"></i>
                    <span className="text-gray-600 text-xs sm:text-sm">Tipo de daños</span>
                  </div>
                  <div className="flex items-center gap-1 sm:gap-2">
                    <i className="ri-arrow-right-s-line text-teal-600"></i>
                    <span className="text-gray-600 text-xs sm:text-sm">Piezas recuperables</span>
                  </div>
                  <div className="flex items-center gap-1 sm:gap-2">
                    <i className="ri-arrow-right-s-line text-teal-600"></i>
                    <span className="text-gray-600 text-xs sm:text-sm">Peso del vehículo</span>
                  </div>
                  <div className="flex items-center gap-1 sm:gap-2">
                    <i className="ri-arrow-right-s-line text-teal-600"></i>
                    <span className="text-gray-600 text-xs sm:text-sm">Demanda de piezas</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 5 */}
            <div className="bg-gray-50 rounded-xl sm:rounded-2xl p-5 sm:p-8 mb-6 sm:mb-8">
              <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                Documentación Necesaria
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4 sm:mb-6 text-sm sm:text-base">
                Para vender tu coche siniestrado en Castelldefels necesitas la siguiente documentación básica:
              </p>
              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-start gap-3 sm:gap-4 bg-white rounded-lg sm:rounded-xl p-3 sm:p-4">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                    <i className="ri-file-user-line text-lg sm:text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1 text-sm sm:text-base">DNI del Propietario</h4>
                    <p className="text-gray-600 text-xs sm:text-sm">Documento de identidad vigente del titular del vehículo siniestrado.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 sm:gap-4 bg-white rounded-lg sm:rounded-xl p-3 sm:p-4">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                    <i className="ri-file-text-line text-lg sm:text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1 text-sm sm:text-base">Permiso de Circulación</h4>
                    <p className="text-gray-600 text-xs sm:text-sm">Documento que acredita que el vehículo puede circular (aunque esté siniestrado).</p>
                  </div>
                </div>
                <div className="flex items-start gap-3 sm:gap-4 bg-white rounded-lg sm:rounded-xl p-3 sm:p-4">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                    <i className="ri-file-list-line text-lg sm:text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1 text-sm sm:text-base">Ficha Técnica</h4>
                    <p className="text-gray-600 text-xs sm:text-sm">Documento con las características técnicas del coche siniestrado.</p>
                  </div>
                </div>
              </div>
              <div className="mt-4 sm:mt-6 bg-teal-50 border border-teal-200 rounded-lg sm:rounded-xl p-3 sm:p-4">
                <p className="text-xs sm:text-sm text-gray-700">
                  <i className="ri-information-line text-teal-600 mr-2"></i>
                  <strong>Nota:</strong> Si te falta algún documento, consúltanos. En muchos casos podemos ayudarte con la gestión de documentación faltante.
                </p>
              </div>
            </div>

            {/* Section 6 */}
            <div className="bg-gray-50 rounded-xl sm:rounded-2xl p-5 sm:p-8">
              <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                Preguntas Frecuentes sobre Coches Siniestrados
              </h3>
              <div className="space-y-3 sm:space-y-4">
                <div>
                  <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">¿Compráis coches siniestrados sin ITV?</h4>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                    Sí, compramos coches siniestrados sin ITV en Castelldefels. No es necesario que el vehículo tenga la ITV en vigor para venderlo a nuestro desguace.
                  </p>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">¿Qué pasa si el coche siniestrado no arranca?</h4>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                    No hay problema. Recogemos coches siniestrados que no arrancan con nuestro servicio de grúa gratuito en Castelldefels. No necesitas mover el vehículo.
                  </p>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">¿Cuánto tiempo tarda la gestión de baja?</h4>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                    Tramitamos la baja definitiva de tu coche siniestrado en 48-72 horas. Te entregamos el certificado de destrucción oficial de la DGT.
                  </p>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1 sm:mb-2 text-sm sm:text-base">¿Puedo vender un coche siniestrado con multas pendientes?</h4>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                    Sí, compramos coches siniestrados con multas pendientes en Castelldefels. Te asesoramos sobre cómo resolver estas situaciones.
                  </p>
                </div>
              </div>
            </div>
          </article>

          {/* Final CTA */}
          <div className="mt-8 sm:mt-12 text-center bg-gradient-to-r from-teal-600 to-cyan-600 rounded-2xl sm:rounded-3xl p-5 sm:p-8 lg:p-12 text-white">
            <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-3 sm:mb-4">
              ¿Tienes un Coche Siniestrado en Castelldefels?
            </h3>
            <p className="text-base sm:text-lg lg:text-xl mb-6 sm:mb-8 text-white/90">
              Solicita tu valoración gratuita ahora. Te respondemos en menos de 1 hora.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
              <a
                href="#valoracion"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('valoracion')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-white text-teal-600 rounded-full text-sm sm:text-lg font-semibold hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-calculator-line text-lg sm:text-xl"></i>
                Valoración Gratuita
              </a>
              <a
                href="tel:932932913"
                className="inline-flex items-center justify-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-gray-900 text-white rounded-full text-sm sm:text-lg font-semibold hover:bg-gray-800 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-phone-line text-lg sm:text-xl"></i>
                932 932 913
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
